import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import Admin from '../views/Admin.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/',
    name: 'admin',
    component: Admin,
    meta: { requiresAuth: true }
  }
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

router.beforeEach(async (to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    const token = localStorage.getItem('token')
    if (!token) {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    } else {
      try {
        const { authAPI } = await import('../services/api')
        const userData = await authAPI.getCurrentUser()
        if (userData.success) {
          const user = userData.data
          const roles = user.roles || []
          const roleNames = roles.map(role => role.name)
          
          if (roleNames.includes('admin') || roleNames.includes('editor')) {
            next()
          } else {
            localStorage.removeItem('token')
            next({ path: '/login' })
          }
        } else {
          localStorage.removeItem('token')
          next({ path: '/login' })
        }
      } catch (error) {
        console.error('权限检查失败:', error)
        localStorage.removeItem('token')
        next({ path: '/login' })
      }
    }
  } else {
    next()
  }
})

export default router
